import { useState, useEffect, React } from "react";
import $ from 'jquery';
// core components
import './Team.css';
import Footer from "../Footer/Footer.js";
import Loader from "../../components/loader/loader.js";
import Team from "../../assets/images/team.png"
import Boardone from "../../assets/images/boardone.png"
import Founder from "../../assets/images/Founder.png"
import Empower from "../../assets/images/empower.png"
import Adopt from "../../assets/images/adopt.png"
import Health from "../../assets/images/Health.png"
import Public from "../../assets/images/Public.png"
import {Link} from "react-router-dom";

export default function Home() {
   const [loading, setLoading] = useState(true);
 
   useEffect(() => {
     const timer = setTimeout(() => {
       setLoading(false);
     }, 2500); 
 
     return () => clearTimeout(timer);
   }, []);
   $(window).scroll(function () {
    if ($(this).scrollTop()) {
      $('header').addClass('fixedTop');
    } else {
      $('header').removeClass('fixedTop');
    }
  });
  useEffect(() => {
     window.scrollTo(0, 0)
   }, [])
  return (
<div>
{loading ? <Loader /> :
    <div>
        <div className="vision_header">
          <section className="vision_banner">
            <div className="container-fluid custom-container">
               <div className="row">
                  <div className="col-md-6 col-sm-12 col-12">
                     <div className="vision_banner_text">
                        <h1>OUR TEAM</h1>
                       </div>
                  </div>
                  <div className="col-md-6 col-sm-12 col-12">
                     <div className="vision_banner_img">
                     <img src={Team} alt="team" className="img-fluid"/>
                     </div>
                  </div>
               </div>
               </div>
            
                  
            </section>
          <section className="Team_content">
            <div className="container-fluid custom_container_inner">
               <h2>Our Team Structure</h2>
              <div className="founder_team">
                  <h3>Founder & Managing Trustee</h3>
                  <div className="founder_team_content">
                     <div className="founder_team_img">
                        <img src={Founder} alt="Founder" className="img-fluid"/>
                     </div>
                     <div className="founder_team_text">
                        <h3>Ms. C. Asreen</h3>
                        <p>Founder & Managing Trustee</p>
                        <h4><span>Ms. C. Asreen,</span> who is currently pursuing her degree in  Ayurvedic Medicine. At a remarkably young age, she envisioned a platform that would uplift lives and break societal barriers. 
"This charitable service, which began at such a young age to help the community flourish, is being brought to the world stage by a shining star.”</h4>
                     </div>
                  </div>
               </div>
              <div className="founder_team">
                  <h3>Board Members</h3>
                  <div className="founder_team_content">
                     <div className="founder_team_img">
                        <img src={Boardone} alt="boardone" className="img-fluid"/>
                     </div>
                     <div className="founder_team_text">
                        <h3>Ms. V. Krishnaveni</h3>
                        <p>1.Board Member</p>
                        <h4>Joining hands with her is<span> Ms. V. Krishnaveni, Member, JCT,</span> an educator and committed learner who embodies warmth, responsibility, and a deep drive to serve.</h4>
                     </div>
                  </div>
                  <div className="founder_team_content">
                     <div className="founder_team_img">
                        <img src={Boardone} alt="boardone" className="img-fluid"/>
                     </div>
                     <div className="founder_team_text">
                        <h3>Mrs. R. Bhuvaneshwari</h3>
                        <p>2.Board Member</p>
                        <h4><span>Mrs. R. Bhuvaneshwari's journey is one of quiet courage. </span>When her husband lost his vision, she turned her pain into purpose. Her compassion, shaped by experience, now helps others find strength in their own journeys.</h4>
                     </div>
                  </div>
               </div>
               <div className="collaborators">
                  <p>Together, this team collaborates to create programs, organize events, and deliver services that promote dignity, independence, and inclusion.</p>
               </div>
            </div>       
         </section>
            
                  
           <Footer />
        </div>
     
    </div>
    }
    </div>
  )
}
